export default function ReviewData() {
  return [
    {
      name: 'Charlene D.',
      avatar: 'none',
      review: '“You are always the first person who comes to mind when I need help. You have always been a lifesaver for me.”'
    },
    {
      name: 'Eddie Y.',
      avatar: 'none',
      review: '“Thanks again for all your patient and invaluable assistance. You are a jewel!”'
    },
    {
      name: 'Suzanne M.',
      avatar: 'none',
      review: '“You’re the best. I am so glad that I have you working with me.”'
    }
  ];
}





// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Navi/ReviewData.js